import { render, staticRenderFns } from "./Messages2.vue?vue&type=template&id=4a918d1a&scoped=true"
import script from "./Messages2.vue?vue&type=script&lang=js"
export * from "./Messages2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a918d1a",
  null
  
)

export default component.exports